// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__1BSJ_","alertIcon":"ConfirmModal_alertIcon__2HA2b"};